'use client';

import { Box } from '@terra/ui-styled-system';
import { Text } from '../../../../../components/text';

type WebSocketUnknownViewProps = {
  raw?: string;
  error?: string;
};

export function WebSocketUnknownView({
  raw,
  error,
}: WebSocketUnknownViewProps) {
  const content = error ?? raw;

  if (!content) {
    return null;
  }

  return (
    <Box
      data-testid="websocket-execution-unknown"
      bg="bg.canvas"
      p={2}
      borderRadius="sm"
      borderWidth="1px"
      borderColor="border.subtle"
      width="100%"
    >
      <Text
        fontSize="xs"
        fontFamily="mono"
        color={error ? 'fg.error' : 'fg.muted'}
        whiteSpace="pre-wrap"
        wordBreak="break-word"
      >
        {content}
      </Text>
    </Box>
  );
}
